import styled, { css, createGlobalStyle } from "styled-components";

import { Time } from "~/Time";

export const ease = () => "ease-in-out" as const;
export const easeIn = () => "ease-in" as const;
export const fast = (): Time.Duration => Time.Duration.milliseconds(90);

export const medium = (): Time.Duration =>
  Time.Duration.milliseconds(fast().duration * 3);

export const slow = (): Time.Duration =>
  Time.Duration.milliseconds(fast().duration * 10);

export namespace Transition {
  export const style = ({ duration }: Time.Duration): Style =>
    `all ${duration}ms ${ease()}`;

  export const styles = (duration: Time.Duration) => css`
    transition: ${style(duration)};
  `;
}

export namespace SlideDown {
  export const style = (duration: Time.Duration): Style =>
    `slideInDown ${duration}ms ${ease()}`;

  export const styles = (duration: Time.Duration) => css`
    animation: ${style(duration)};
  `;

  export const Component = styled.div`
    ${() => styles(slow())}
  `;
}

export namespace FadeIn {
  export const style = (duration: Time.Duration): Style =>
    `fadeIn ${duration}ms ${easeIn()}`;

  export const styles = (duration: Time.Duration) => css`
    animation: ${style(duration)};
  `;

  export const Component = styled.div`
    ${() => styles(slow())}
  `;
}

export namespace Keyframes {
  export const Component = createGlobalStyle`
    @keyframes slideInDown {
      from {
        transform: translate3d(0, -100%, 0);
        visibility: visible;
      }
    
      to {
        transform: translate3d(0, 0, 0);
      }
    }
    
    @keyframes fadeIn {
      from {
        opacity: 0;
      }
    
      to {
        opacity: 1;
      }
    }
  `;
}
